import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import { NotificationProvider } from "./context/NotificationContext";
import SignUp from "./components/Authentication/SignUp";
import Profile from "./components/Tabs/Profile";
import NavBar from "./components/Tabs/NavBar";
import ProtectedRoute from "./components/ProtectedRoute";
import ScoutRoute from "./components/ScoutRoute";
import ComingSoon from "./components/ComingSoon";
import Explore from "./components/Tabs/Explore";
import PublicProfile from "./components/Tabs/PublicProfile";
import PublicOrgProfile from "./components/Tabs/PublicOrgProfile";
import Favorites from "./components/Tabs/Favorites";
import Events from "./components/Tabs/Events";
import Messages from "./components/Tabs/Messages";
import Connections from "./components/Tabs/Connections";
import Notifications from "./components/Tabs/Notifications";
import OnboardingOrg from "./components/OnboardingOrg";
import OrgDashboard from "./components/OrgDashboard";
import HomeEntryRoute from "./components/HomeEntryRoute";

function App() {
  return (
    <NotificationProvider>
      <NavBar />
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Navigate to="/home" replace />} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/home" element={<HomeEntryRoute />} />
        <Route path="/settings" element={<ProtectedRoute><ComingSoon /></ProtectedRoute>} />
        <Route path="/explore" element={<ProtectedRoute><Explore /></ProtectedRoute>} />
        <Route path="/player/:id" element={<ProtectedRoute><PublicProfile /></ProtectedRoute>} />
        <Route path="/org/:id" element={<ProtectedRoute><PublicOrgProfile /></ProtectedRoute>} />
        <Route path="/scout/favorites" element={<ScoutRoute><Favorites /></ScoutRoute>} />
        <Route path="/events" element={<ProtectedRoute><Events /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
        <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
        <Route path="/connections" element={<ProtectedRoute><Connections /></ProtectedRoute>} />
        <Route path="/onboarding/org" element={<ProtectedRoute><OnboardingOrg /></ProtectedRoute>} />
        <Route path="/org/dashboard" element={<ProtectedRoute><OrgDashboard /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </NotificationProvider>
  );
}

export default App;
